import React, {useState} from "react";
import {Button} from "../ui/button";
import {FileDown} from "lucide-react";
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "../ui/tooltip";
import {useToast} from "../ui/use-toast";
import {BidExtendedModel} from "./bidding_model";
import {Cell} from "../project_conf/bidConfig_model";

type SavePdfButtonProps = {
    bid: BidExtendedModel;
    sheetData: Cell[][] | null;
};

export function SavePdfButton({bid, sheetData}: SavePdfButtonProps) {
    const {toast} = useToast();
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        setLoading(true);
        try {
            const {generateBidPdf} = await import("./generateBidPdf");
            await generateBidPdf(bid, sheetData);
        } catch (err) {
            console.error(err);
            toast({
                title: "Error",
                description: "Failed to generate PDF.",
                variant: "destructive",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button onClick={handleClick} type="button" variant="outline" disabled={loading}>
                        <FileDown width={17} height={17}/>
                    </Button>
                </TooltipTrigger>
                <TooltipContent>
                    <p>Save as PDF</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
